__turbopack_context__.v({
  "active": "Header-module__ldgnoG__active",
  "contactUs": "Header-module__ldgnoG__contactUs",
  "header": "Header-module__ldgnoG__header",
  "navItems": "Header-module__ldgnoG__navItems",
});
